import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from "react-router-dom";
import { Form, Button } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

// datetime-local <-> ISO helpers. The input works in the browser's local time; the API stores absolute
// content-time (UTC), so we convert on the boundary.
const isoToLocalInput = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    const off = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - off).toISOString().slice(0, 16);
};
const localInputToIso = (local) => (local ? new Date(local).toISOString() : null);

const MomentTriggerForm = (props) => {
    const [Tokens, setTokens] = useState([]);
    const [Token, setToken] = useState(0);
    const [TriggerToken, setTriggerToken] = useState(0);
    const [Label, setLabel] = useState('');
    const [ContentStart, setContentStart] = useState('');
    const [ContentEnd, setContentEnd] = useState('');
    const [Enabled, setEnabled] = useState(true);
    const [loadingData, setLoadingData] = useState(false);
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const history = useHistory();

    const getById = async () => {
        if (id > 0) {
            setLoadingData(true);
            try {
                api.get("momenttrigger/" + id)
                    .then(function (response) {
                        if (response.status == 200) {
                            var result = response.data;
                            setToken(result.token);
                            setTriggerToken(result.trigger_token);
                            setLabel(result.label);
                            setContentStart(isoToLocalInput(result.content_start));
                            setContentEnd(isoToLocalInput(result.content_end));
                            setEnabled(result.is_active);
                        }
                        setLoadingData(false);
                    })
                    .catch(function (error) {
                        toast.error('An error occurred !', { position: toast.POSITION.TOP_RIGHT });
                        setLoadingData(false);
                    });
            } catch (err) {
                toast.error('An error occurred !', { position: toast.POSITION.TOP_RIGHT });
                setLoadingData(false);
            }
        }
    }

    const saveData = async (e) => {
        e.preventDefault();
        setLoadingData(true);
        const payload = {
            token: Token > 0 ? Token : e.target.elements.Token.value,
            trigger_token: TriggerToken > 0 ? TriggerToken : e.target.elements.TriggerToken.value,
            label: Label,
            content_start: localInputToIso(ContentStart),
            content_end: localInputToIso(ContentEnd),
            is_active: Enabled,
        };
        const onError = (error) => {
            const detail = error?.response?.data;
            const message = detail && typeof detail === 'object'
                ? Object.values(detail).flat().join(' ')
                : 'An error occurred !';
            toast.error(message, { position: toast.POSITION.TOP_RIGHT });
            setLoadingData(false);
        };
        const onOk = (response) => {
            if (response.status == 200 || response.status == 204) {
                toast.success('Successful Operation !', { position: toast.POSITION.TOP_RIGHT });
                return history.push('/manage/momenttriggers');
            }
        };
        try {
            if (id > 0) {
                api.put('momenttrigger/' + id, payload).then(onOk).catch(onError);
            } else {
                api.post('momenttrigger', payload).then(onOk).catch(onError);
            }
        } catch (err) {
            setLoadingData(false);
        }
    }

    const getTokens = async () => {
        setLoadingData(true);
        try {
            api.get('tokens?limit=1000')
                .then(function (response) {
                    if (response.status == 200) {
                        setTokens(response.data.results);
                    }
                    setLoadingData(false);
                })
                .catch(function (error) {
                    setLoadingData(false);
                });
        } catch (err) {
            setLoadingData(false);
        }
    }

    useEffect(() => {
        getTokens();
        getById();
        var selector = document.getElementById('title-section-id');
        if (selector != undefined) {
            selector.textContent = id > 0 ? "Edit Moment Trigger" : "Create Moment Trigger";
        }
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <Form className="create-form" onSubmit={saveData} autoComplete="off">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Stream Token</Form.Label>
                                    <select className="form-control" name="Token" value={Token} onChange={(e) => setToken(e.target.value)}>
                                        <option value={0}>Select a token…</option>
                                        {Tokens.map((item, i) => (
                                            <option key={i} value={item.id}>{item.name}</option>
                                        ))}
                                    </select>
                                    <small className="form-text text-muted">The live/recorded stream being listened to.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Trigger Content Token</Form.Label>
                                    <select className="form-control" name="TriggerToken" value={TriggerToken} onChange={(e) => setTriggerToken(e.target.value)}>
                                        <option value={0}>Select a token…</option>
                                        {Tokens.map((item, i) => (
                                            <option key={i} value={item.id}>{item.name}</option>
                                        ))}
                                    </select>
                                    <small className="form-text text-muted">The special token whose scheduled content is shown when the moment fires.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-12 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Label</Form.Label>
                                    <Form.Control type="text" placeholder="e.g. Goal" value={Label} onChange={(e) => setLabel(e.target.value)} />
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Content Start</Form.Label>
                                    <Form.Control type="datetime-local" required value={ContentStart} onChange={(e) => setContentStart(e.target.value)} />
                                    <small className="form-text text-muted">Absolute content-time the moment window opens. The match-day console can set this from the live player position.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Content End</Form.Label>
                                    <Form.Control type="datetime-local" required value={ContentEnd} onChange={(e) => setContentEnd(e.target.value)} />
                                    <small className="form-text text-muted">Absolute content-time the window closes. Wider windows absorb more viewer stream delay.</small>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Enabled</Form.Label>
                                    <Form.Check name="Enabled" type="checkbox" checked={Enabled} onChange={(e) => setEnabled(!Enabled)} />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-12 footer-form">
                                <NavLink className="btn btn-secondary" to="/manage/momenttriggers"><i className="fa fa-fw fa-times"></i> Cancel</NavLink>
                                <Button className="btn btn-primary" type='submit'><i className="fa fa-fw fa-floppy-o"></i> Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default MomentTriggerForm;
